module.exports = __webpack_public_path__ + "static/media/meghalaya.ac1d389d.png";